import type { VFC } from 'react';
import { Layout } from 'components/layout';
import { Col, Row, Space, Tabs } from 'antd';
// @ts-expect-error - icon is not exported from 'images/logo-inverse.svg?react'
import LogoInverse from 'images/logo-inverse.svg?react';
import { TokenRenewal } from './TokenRenewal';
import { LoginForm } from './LoginForm';

export const LoginPage: VFC = () => (
  <Layout style={{ height: '100%' }}>
    <Layout.Header />
    <Layout.Content style={{ overflow: 'auto' }}>
      <Row align="middle" justify="center" style={{ height: '100%' }}>
        <Col flex="400px">
          <Space direction="vertical" size={32} style={{ display: 'flex' }}>
            <Row justify="center">
              <Col>
                <LogoInverse />
              </Col>
              <Col>
                <b>Tools</b>
              </Col>
            </Row>
            <TokenRenewal>
              <Tabs
                defaultActiveKey="login"
                items={[
                  {
                    key: 'login',
                    label: 'Log in',
                    children: <LoginForm />,
                  },
                ]}
              />
            </TokenRenewal>
          </Space>
        </Col>
      </Row>
    </Layout.Content>
  </Layout>
);
